import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@/contexts/auth-context'

export const Route = createFileRoute('/_authenticated/success')({
  component: SuccessPage,
})

function SuccessPage() {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <div>Failed to load user information. Please try again.</div>
  }

  return <div>Welcome, {user.name}!</div>
}
